import { getCurrentBrowserFingerPrint } from "./fingerprint/fingerprint"
import { Collector } from "./collector/collector";
import { Config } from "./collector/config";
import { Helper } from "./collector/helper";
import { Url } from "./collector/url";
import { Cookie } from "./collector/cookie";
import { FormTool } from "./forms/FormTool.js"
import {isbot} from 'isbot'
import { UAParser } from 'ua-parser-js';

//
// Collector tools 
// 

// Private methods to get fingerprint and apply collectior
const getBrowserFingerPrint = () => {
    Config.external = true;
    getCurrentBrowserFingerPrint().then((res) => {
        // set initial page load
        Config.fingerprint = res;
        //console.log(res);
        applyCollector("event", "pageload");
        // set event if in params
        let eventparam = Url.getParameterByName('bonsait_collect');
        if (eventparam) {
            applyCollector("event", eventparam);
        }
    }).catch((err) => {
        console.error(err);
    })
}

const applyCollector = (method, value, optional) => {
    Config.external = false;
    // Check first if user is bot or similar so we don't track these
    if (!isbot(navigator.userAgent)) {
        if (method === "init") {
            Config.id = value;
        } else if (method==="param") {
            Config.params[value] = () => optional
        } else if (method==="event") {
            if (value==='pageload' && !Config.pageLoadOnce) {
                Config.pageLoadOnce = true;
                new Collector(value, Helper.now(), optional);
            } else if (value!=='pageload' && value!=='pageclose') {
                new Collector(value, Helper.now(), optional);
            }
        }
    }
}

const setupCollector = () => {
    // update the cookie if it exists, if it doesn't, create a new one, lasting 2 years
    // Cookie.exists('uid') ? Cookie.set('uid', Cookie.get('uid'), 2*365*24*60) : Cookie.set('uid', Helper.guid(), 2*365*24*60);

    // trying to work without cookies as promised so delete uid cookie from user if any.
    //document.cookie = "__BonsaitCollector_uid=; expires=Thu, 01 Jan 1970 00:00:00 GMT; SameSite=Lax; domain=" + window.location.hostname + ";"
    //document.cookie = "__BonsaitCollector_uid=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; SameSite=Lax; domain=" + window.location.hostname + ";"
    document.cookie = "__BonsaitCollector_uid=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
    
    // save any utms through as session cookies
    Cookie.setUtms();

    // https://github.com/GoogleChromeLabs/page-lifecycle/blob/master/src/Lifecycle.mjs
    // Safari does not reliably fire the `pagehide` or `visibilitychange`
    var isSafari = typeof safari === 'object' && safari.pushNotification;
    var isPageHideSupported = 'onpageshow' in self;

    // IE9-10 do not support the pagehide event, so we fall back to unload
    // pagehide event is more reliable but less broad than unload event for mobile and modern browsers
    var pageCloseEvent = isPageHideSupported && !isSafari ? 'pagehide' : 'unload';

    // Add event listener to page close so we can track time.
    window.addEventListener(pageCloseEvent, function() {
        if (!Config.pageCloseOnce) {
            Config.pageCloseOnce = true;
            new Collector('pageclose', Helper.now(), function() {
                // if a link was clicked in the last 5 seconds that goes to an external host, pass it through as event data
                if (Helper.isPresent(Config.externalHost) && (Helper.now() - Config.externalHost.time) < 5*1000) {
                    return Config.externalHost.link;
                }
            });
        }
    });

    // Put click detection to anchors. Also track anchors with BonsaitCollector-event data attribute

    window.addEventListener('load', function() {
        var aTags = document.getElementsByTagName('a');
        for (var i = 0, l = aTags.length; i < l; i++) {
            aTags[i].addEventListener('click', function(_e) {
                if (Url.externalHost(this)) {
                    Config.externalHost = { link: this.href, time: Helper.now() };
                }
            }.bind(aTags[i]));
        }
        var dataAttributes = document.querySelectorAll('[data-BonsaitCollector-event]')
        for (var i = 0, l = dataAttributes.length; i < l; i++) {
            dataAttributes[i].addEventListener('click', function(_e) {
                var event = this.getAttribute('data-BonsaitCollector-event');
                if (event) {
                    new Collector(event, Helper.now(), this.getAttribute('data-BonsaitCollector-event'));
                }
            }.bind(dataAttributes[i]));
        }
    });

}


export const collect = (type, arg2, arg3) => {
    if (type) {
        try {
            if (type=='pageview') {
                // If arg2 is defined it's sitename else do this site
                if (arg2) {
                    Config.id = arg2;
                    Config.external = true;
                    getBrowserFingerPrint();
                } else {
                    getBrowserFingerPrint();
                }
            } else if (type=='event') {
                // If arg3 is defined it's sitename else do this site
                // collect('event', [eventname], [sitename]);
                if (arg3) {
                    Config.id = arg3;
                    Config.external = true;
                    applyCollector("event", arg2);
                } else {
                    applyCollector("event", arg2);
                }
            } else if (type=='setup') {
                setupCollector();
                // also do initial pageview
                getBrowserFingerPrint();
            }
            return true;
        } catch (error) {
            console.error(error)
            return false;
        }
    }
}

// DEPRECATED
// method to collect events / Bonsait.collectEvent('myEvent', '[sitename]')
export const collectEvent = (name, sitename) => {
    if (!name) {
        return false;
    }
    return collect('event', name, sitename);
}


//
// Form tools 
//
export const forms = (type, arg2) => {
    if (type) {
        try {
            if (type=='setup') {
                if (arg2) {
                    FormTool.deSpam(arg2);
                } else {
                    FormTool.init();
                }
            } else if (type=='hpi') {
                return FormTool.calcHPI();
            }
            return true;

        } catch (error) {
            console.error(error)
            return false;

        }
    }
}

//
// Helper tools 
//
export const getBrowser = () => {
    const { browser } = UAParser(window.navigator.userAgent);
    return browser;
}
export const isMobile = () => {
    return (('ontouchstart' in window) || (navigator.maxTouchPoints > 0) || (navigator.msMaxTouchPoints > 0));
}
export const getDevice = () => {
    const { device } = UAParser(window.navigator.userAgent);
    return device;
}
// Cookie setter and getter -> setCookie("cookiename", "cookievalue", 365)
export const setCookie = (cname, cvalue, exdays) => {
    let d = new Date();
	d.setTime(d.getTime() + (exdays*24*60*60*1000));
	let expires = "expires="+ d.toUTCString();
	document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}
export const getCookie = (cname,) => {
    let name = cname + "=";
	let decodedCookie = decodeURIComponent(document.cookie);
	let ca = decodedCookie.split(';');
	for (let i = 0; i <ca.length; i++) {
		let c = ca[i];
		while (c.charAt(0) == ' ') {
			c = c.substring(1);
		}
		if (c.indexOf(name) == 0) {
			return c.substring(name.length, c.length);
		}
	}
	return "";
}
export const getNumberValue = (value) => {
    if (value) {
		try {
			// only digits
			if (typeof value === 'string' || value instanceof String) {
				value = value.replace(/[^-\d\.]/g, '');
			}
			let newvalue = parseFloat(value).toFixed(0);
			if (newvalue) {
				return Number(newvalue)
			}
		} catch (error) {
		}
	}
	return 0
}
export const getParameterByName = (name) => {
    const url = window.location.href;
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)", "i"),
    results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
}
